<template>
    <div class="paragraph">
      <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'app-paragraph',
  props: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/css/system/_vars';
    @import '../../../assets/css/system/_mixins';

    .paragraph {
        width: 100%;
        max-width: 700px;
    }
</style>
